import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAnnouncements(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('customer/announcements', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteAnnouncement(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`customer/announcements/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
